import { styled } from '@mui/material/styles';

import TableCell from '@mui/material/TableCell';

const TableBodyRowActionCell = styled(props => <TableCell align="right" {...props} />)(() => ({
  padding: 0,
}));

export default TableBodyRowActionCell;
